import { memo } from 'react';

import { useCommonStore } from '@/store';

import {
  ScLeftArrowOutside,
  ScOutsideArrows,
  ScOutsideArrowsContainer,
  ScRightArrowOutside,
} from './styled';

interface IOutsideArrows {
  rightComponent?: React.ReactNode;
  leftComponent?: React.ReactNode;
  visibleForMobile?: boolean;
  isBeginning: boolean;
  isEnd: boolean;
  dark?: boolean;
  handlePrevClick: () => void;
  handleNextClick: () => void;
}

export const OutsideArrows = memo(
  ({
    rightComponent,
    leftComponent,
    visibleForMobile,
    handlePrevClick,
    handleNextClick,
    isBeginning,
    isEnd,
    dark,
  }: IOutsideArrows) => {
    const isMobileDevice = useCommonStore.use.isMobileDevice();

    return (
      <ScOutsideArrowsContainer visibleArrowsForMobile={visibleForMobile}>
        {leftComponent}
        <div>
          {rightComponent}
          {(!isMobileDevice || visibleForMobile) && (
            <ScOutsideArrows dark={dark}>
              <ScLeftArrowOutside
                onClick={handlePrevClick}
                isActive={!isBeginning}
                aria-label="arrow left"
              />
              <div className="divider" />
              <ScRightArrowOutside
                onClick={handleNextClick}
                isActive={!isEnd}
                aria-label="arrow right"
              />
            </ScOutsideArrows>
          )}
        </div>
      </ScOutsideArrowsContainer>
    );
  }
);
